import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function PageClassesManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    const body = document.body;
    const html = document.documentElement;

    // 🔹 Limpia todas las clases previas del body y html
    body.className = "";
    html.className = "";

    // 🔹 Aplica la clase según la ruta actual
    if (pathname.includes("contacto")) {
      body.classList.add("contacto");
      html.classList.add("contacto");
    }

    if (pathname.includes("servicios")) {
      body.classList.add("servicios");
      html.classList.add("servicios");
    }

    if (pathname.includes("clientes")) {
      body.classList.add("clientes");
      html.classList.add("clientes");
    }

    if (pathname.includes("nosotros") || pathname === "/") {
      body.classList.add("nosotros");
      html.classList.add("nosotros");
    }

    // 🔹 Al cambiar de página, limpia todo antes de aplicar clases nuevas
    return () => {
      body.className = "";
      html.className = "";
    };
  }, [pathname]);

  return null; // Este componente no renderiza nada
}
